import type { FC } from 'react';
import { Picture } from '@ui';
import { selectedItemRed } from '@images';
import { DELIVERY_ID, PICKUP_ID } from '../constants';

interface DeliveryTypeToggleProps {
  isPickupCart: boolean;
  onChangeType: (id: number) => () => void;
}

const DeliveryTypeToggle: FC<DeliveryTypeToggleProps> = ({
  isPickupCart,
  onChangeType
}) => (
  <div className='pickupBtns'>
    <div
      onClick={onChangeType(DELIVERY_ID)}
      className={`chooseButton${!isPickupCart ? ' active' : ''}`}
    >
      {!isPickupCart && (
        <Picture className='icon' icon={selectedItemRed} height='20' alt='' />
      )}
      Курьер
    </div>
    <div
      onClick={onChangeType(PICKUP_ID)}
      className={`chooseButton${isPickupCart ? ' active' : ''}`}
    >
      {isPickupCart && (
        <Picture className='icon' icon={selectedItemRed} height='20' alt='' />
      )}
      Самовывоз
    </div>
  </div>
);

export default DeliveryTypeToggle;
